<template>
  <div class="prepay-detail">
    <h3>职位详情</h3>
    <el-form
      :model="jobInfo"
      :rules="rules"
      ref="jobInfo"
      class="demo-form-inline"
      size="mini"
      label-width="180px"
    >
      <el-form-item label="岗位名称" prop="name">
        <el-input type="text" v-model="jobInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="岗位标题" prop="title">
        <el-input type="text" v-model="jobInfo.title"></el-input>
      </el-form-item>
      <el-form-item label="工作内容" prop="description">
        <el-input
          type="textarea"
          rows="2"
          v-model="jobInfo.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="乙方最小工作产出" prop="deliverable">
        <el-input
          type="textarea"
          rows="2"
          v-model="jobInfo.deliverable"
        ></el-input>
      </el-form-item>
      <el-form-item label="需要甲方提供的内容" prop="provideContent">
        <el-input
          type="textarea"
          rows="2"
          v-model="jobInfo.provideContent"
        ></el-input>
      </el-form-item>

      <el-form-item label="每日工作时长" prop="hourPerDay">
        <el-input v-model.number="jobInfo.hourPerDay"></el-input>
      </el-form-item>
      <el-form-item label="岗位时薪" prop="hourlyRate">
        <el-input v-model.number="jobInfo.hourlyRate"></el-input>
      </el-form-item>
      <el-form-item label="传统招聘月薪" prop="traditionMonthlyRate">
        <el-input v-model.number="jobInfo.traditionMonthlyRate"></el-input>
      </el-form-item>
      <el-form-item label="乙方ID" prop="userId">
        <el-input type="text" v-model="jobInfo.userId"></el-input>
      </el-form-item>
      <!-- <el-form-item label="岗位类目"> </el-form-item> -->
      <el-form-item label="职位类型" prop="jobCategory">
        <el-select
          v-model="jobInfo.jobCategory"
          value-key="id"
          placeholder="请选择"
          @change="cateChange('jobCategory')"
        >
          <el-option
            v-for="item in firstCates"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属职业" prop="skillCategory">
        <el-select
          v-model="jobInfo.skillCategory"
          :multiple="true"
          :multiple-limit="1"
          value-key="id"
          placeholder="请选择"
          @change="cateChange('skillCategory')"
        >
          <el-option
            v-for="item in secondCates"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="技能标签" prop="thirdCategory">
        <el-select
          v-model="jobInfo.thirdCategory"
          :multiple="true"
          value-key="id"
          placeholder="请选择"
        >
          <el-option-group
            v-for="group in jobInfo.skillCategory"
            :key="group.id"
            :label="`${group.name}：`"
          >
            <el-option
              v-for="item in getCatesById(group.id)"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "../api";
const { standardJob } = api;

export default {
  name: "jobDetail",
  data() {
    return {
      customTags: [],
      cates: [],
      jobInfo: {
        title: "",
        name: "",
        // status: 1,
        description: "",
        hourPerDay: 0,
        deliverable: "",
        provideContent: "",
        jobName: "",
        hourlyRate: "",
        traditionMonthlyRate: "",
        jobCategory: {
          id: "",
          name: "",
        },
        skillCategory: [],
        thirdCategory: [],
        customTags: [],
        userId: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入岗位名称",
            trigger: "blur",
          },

          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        userId: [
          {
            required: true,
            message: "请输乙方userId",
            trigger: "blur",
          },
        ],

        hourPerDay: [
          {
            required: true,
            message: "每日工作时长",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              // 检查是否为整数
              const intValue = Number(value);
              if (!Number.isInteger(intValue)) {
                return callback(new Error("每日工作时长必须为整数"));
              }
              // 检查范围
              if (intValue < 1) {
                return callback(new Error("每日工作时长最少1小时"));
              }
              if (intValue > 8) {
                return callback(new Error("每日工作时长最大8小时"));
              }
              // 验证通过
              callback();
            },
            trigger: "blur",
          },
        ],
        hourlyRate: [
          {
            required: true,
            message: "请输入岗位时薪",
            trigger: "blur",
          },
          {
            validator: this.hourAmount,
            trigger: "blur",
          },
        ],
        traditionMonthlyRate: [
          {
            required: true,
            message: "请输入传统招聘月薪",
            trigger: "blur",
          },
          {
            validator: this.traditionAmount,
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入岗位标题",
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "blur",
          },
        ],

        description: [
          {
            required: true,
            message: "请选择输入工作内容",
          },
          {
            min: 20,
            max: 1000,
            message: "长度在 20 到 1000 个字符",
            trigger: "blur",
          },
        ],

        provideContent: [
          {
            required: true,
            message: "请选择输入甲方提供的内容",
          },
          {
            min: 4,
            max: 1000,
            message: "长度在 4 到 1000 个字符",
            trigger: "blur",
          },
        ],
        deliverable: [
          {
            required: true,
            message: "请选择输入乙方最小工作产出",
          },
          {
            min: 4,
            max: 1000,
            message: "长度在 4 到 1000 个字符",
            trigger: "blur",
          },
        ],

        jobCategory: [
          {
            required: true,
            message: "请选择职位类型",
          },
        ],
        skillCategory: [
          {
            required: true,
            message: "请选择所属行业",
          },
        ],
        // thirdCategory: [{
        //     required: true,
        //     message: '请选择技能标签',
        // }],
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    monthlyRate() {
      return this.jobInfo.hourlyRate * this.jobInfo.hourPerDay * 22;
    },
    firstCates() {
      return this.getCatesById(0);
    },

    action() {
      return this.id ? "update" : "insert";
    },

    secondCates() {
      return this.getCatesById(this.jobInfo.jobCategory.id);
    },
  },
  watch: {},
  mounted() {
    if (this.id) {
      this.getDetail();
    }
    this.getAllTags();
  },
  methods: {
    hourAmount(rule, value, callback) {
      // 检查是否为整数
      const intValue = Number(value);
      if (!Number.isInteger(intValue)) {
        return callback(new Error("岗位时薪必须为整数"));
      }

      callback();
    },
    traditionAmount(rule, value, callback) {
      // 检查是否为整数
      const intValue = Number(value);
      if (!Number.isInteger(intValue)) {
        return callback(new Error("传统招聘月薪必须为整数"));
      }

      // 检查范围
      if (intValue < 1) {
        return callback(new Error("传统招聘月薪不能小于1元"));
      }
      if (intValue < this.monthlyRate) {
        return callback(new Error("传统招聘月薪不能小于岗位月薪"));
      }
      // 验证通过
      callback();
    },
    async getDetail() {
      console.log("idEnc");
      let {
        data: { code, data },
      } = await standardJob.detail({
        id: this.id,
      });
      if (code == 200) {
        this.jobInfo = data;
        this.getAllTags();
      }
    },
    submit() {
      this.$refs.jobInfo.validate((valid) => {
        if (valid) {
          let jobInfo = this.jobInfo;
          let skills = jobInfo.thirdCategory.concat(jobInfo.customTags);
          if (skills.length) {
            this.update();
          } else {
            this.$message.error("技能标签不能为空");
          }
        } else {
          return false;
        }
      });
    },
    async update() {
      console.log(this.action);
      let obj = this.jobInfo;
      let {
        data: { code },
      } = await standardJob[this.action]({
        id: this.id ? this.id : "",
        title: this.jobInfo.title,
        name: this.jobInfo.name,
        hourPerDay: this.jobInfo.hourPerDay,
        monthlyRate: this.monthlyRate,
        description: this.jobInfo.description,
        deliverable: this.jobInfo.deliverable,
        provideContent: this.jobInfo.provideContent,
        userId: this.jobInfo.userId,
        jobCategory: this.jobInfo.jobCategory,
        skillCategory: this.jobInfo.skillCategory,
        traditionMonthlyRate: this.jobInfo.traditionMonthlyRate,
        thirdCategory: this.jobInfo.thirdCategory,
        hourlyRate: this.jobInfo.hourlyRate,
      });
      if (code == 200) {
        let vue = this;
        this.$message({
          showClose: false,
          message: "保存成功",
          type: "success",
          onClose() {
            window.location.href = `/standardJob`;
          },
        });
      }
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await api.workCateList.getAllTags({
        publisherIdEnc: this.jobInfo.publisherIdEnc,
      });
      if (code == 200) {
        this.cates = data.workCategory;
        this.customTags = data.customTags;
      }
    },
    formatCustomTags(customTags) {
      customTags.forEach((item) => {
        item.isCustom = true;
      });
      return customTags;
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    cateChange(name) {
      switch (name) {
        case "jobCategory":
          this.jobInfo["skillCategory"] = [];
          this.jobInfo["thirdCategory"] = [];
          break;
        case "skillCategory":
          this.delThirdCates();
          break;
        default:
      }
    },
    inArr(id, array) {
      let isIn = false;
      array.forEach((item) => {
        if (item.id === id) {
          isIn = true;
        }
      });
      return isIn;
    },
    delThirdCates() {
      let thirdCates = this.jobInfo.thirdCategory;
      let newArr = [];
      thirdCates.forEach((item) => {
        if (this.inArr(item.parentId, this.jobInfo.skillCategory)) {
          newArr.push(item);
        }
      });
      this.jobInfo.thirdCategory = newArr;
    },
  },
};
</script>
<style scoped>
.demo-form-inline {
  width: 640px;
}
</style>



// WEBPACK FOOTER //
// src/views/standardJob/detail.vue